
interface Form {
  name: string;
  community: number;
  status: string;
}
import { Component, Vue } from 'vue-property-decorator';
import { STATUS_LIST } from '@/constants';
const dateFormat = require('bmh/date-format');
const { VUE_APP_FCAPI: FCAPI } = process.env;
const API = {
  sample: `${FCAPI}/boss/ruan/sample`,
  community: `${FCAPI}/boss/ruan/community/name`,
};
@Component
export default class RuanSampleRoomList extends Vue {
  is_loading = false;
  form: Form = {
    name: '',
    community: 0,
    status: '0',
  };
  community_list = [];
  community_list_obj: any = {};
  status_list = STATUS_LIST;
  table_data = {};
  page = 1;

  handChangePaging(pagination: any) {
    const next_page = pagination.current;
    this.query(next_page);
  }

  paginationOption(data: Pagination<any>) {
    return {
      total: data.total || 0,
      showTotal: () => `共${data.total}条，每页${data.limit}条`,
      pageSize: data.limit || 1,
      current: data.current || 1,
    };
  }

  dateFormat(time: any) {
    return dateFormat(new Date(time * 1000), '%Y-%m-%d %H:%M:%S');
  }

  async onChangeSort(item: any) {
    const res = await this.$axios.put(`${API.sample}/${item.id}`, {
      sort: item.sort,
    });
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.$message.success('修改成功');
    await this.query(this.page);
  }

  async onChangeOnlineStatus(item: any) {
    const res = await this.$axios.put(`${API.sample}/${item.id}`, {
      is_show: item.is_show === 1 ? 2 : 1,
    });
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    await this.query(this.page);
  }

  async getCommunity() {
    const res = await this.$axios.get(API.community);
    if (res.data.status !== 200) {
      return;
    }
    const data = res.data.data || {};
    this.community_list = data;
    this.community_list.forEach((item: any) => {
      this.community_list_obj[item.id] = item.name;
    });
  }

  submit() {
    this.query(1);
  }

  async query(page = 1) {
    this.page = page;
    const form = this.form;
    const send_data = {
      current: page,
      name: form.name,
      community_id: form.community || '',
      is_show: form.status === 'on' ? 1 : form.status === 'off' ? 2 : '',
    };
    const res = await this.$axios.get(API.sample, { params: send_data });
    if (res.data.status !== 200) {
      this.table_data = {};
      return;
    }
    const data = res.data.data || {};
    this.table_data = data;
  }

  clearForm() {
    const form = this.form;
    form.name = '';
    form.community = 0;
    form.status = '0';
  }

  async created() {
    await this.getCommunity();
    await this.query(1);
  }
}
